import { Injectable } from '@angular/core';
//import { environment } from '../../../environments/environment';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { catchError, debounceTime } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient
  ) { }

  private formatErrors(error: any) {
    return throwError(error.error);
  }

  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    const headers = new HttpHeaders();
    headers.set('Accept', 'application/json');
    headers.set('Content-Type', 'application/json');
    return this.http.get(`${environment.apiEndpoint}${path}`, { headers, params })
      .pipe(catchError(this.formatErrors));
  }

  put(path: string, body: any = {}): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return this.http.put(
      `${environment.apiEndpoint}${path}`,
      body, { headers }
    ).pipe(catchError(this.formatErrors));
  }

  patch(path: string, body: any = {}): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return this.http.patch(
      `${environment.apiEndpoint}${path}`,
      body, { headers }
    ).pipe(catchError(this.formatErrors));
  }

  post(path: string, body: any = {}): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return this.http.post(
      `${environment.apiEndpoint}${path}`,
      body, { headers }
    ).pipe(catchError(this.formatErrors));
  }

  postWithoutLoading(path: string, body: any = {}): Observable<any> {
    // const headers = new HttpHeaders();
    // headers.append('Accept', 'application/json');
    // headers.append('Content-Type', 'application/json');
    // headers.append('IsShowLoading', 'false');

    const headers = {
      'IsShowLoading': 'false',
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }

    return this.http.post(
      `${environment.apiEndpoint}${path}`,
      body, { headers }
    ).pipe(catchError(this.formatErrors));

    // const headers = {
    //   'IsShowLoading': 'false'
    // }
    // if(path.includes('https://'))
    //   return this.http.get(`${path}`, { 'headers': headers, params }).pipe(catchError(this.formatErrors));
    // return this.http.get(`${environment.apiEndpoint}${path}`, {headers, params }).pipe(catchError(this.formatErrors));
  }

  httpPost(path: string, body: any = {}): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    return this.http.post(
      `${environment.apiEndpoint}${path}`,
      body, { headers }
    );
  }

  httpPostDownloadFile(path: string, body: any = {}, options: any = {}): Observable<any> {
    return this.http.post(
      `${environment.apiEndpoint}${path}`,
      body, options
    );
  }

  httpFormPost(path: string, body: any = {}): Observable<any> {
    let headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    //headers.append('content-type', 'application/x-www-form-urlencoded');
    headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(
      `${environment.apiEndpoint}${path}`,
      body, { headers }
    ).pipe(catchError(this.formatErrors));
  }

  delete(path: string): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    return this.http.delete(
      `${environment.apiEndpoint}${path}`, { headers }
    ).pipe(catchError(this.formatErrors));
  }

  downloadFile(path: string): Observable<Blob> {
    return this.http.get<Blob>(`${environment.apiEndpoint}${path}`, { responseType: 'blob' as 'json' });
  }

  postDownloadFile(path: string, model: any): Observable<Blob> {
    return this.http.post<Blob>(`${environment.apiEndpoint}${path}`, model, { responseType: 'blob' as 'json' });
  }

  postFile(path: string, model: any): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(`${environment.apiEndpoint}${path}`, model)
      .pipe(catchError(this.formatErrors));
  }
}
